import { useAuthStore } from '@/entities/session/model/authStore';
import {
  getTopRole,
  getRoleForDeployment,
  isRipikStaff,
  isRipikAdmin,
  canManageUsers,
  canViewDeployment,
  canViewSettings,
} from '@/entities/rbac/lib/permissions';

export function usePermissions() {
  const { assignments, isInternalRipik } = useAuthStore();

  return {
    topRole: getTopRole(assignments),
    isRipikStaff: isRipikStaff(assignments),
    isRipikAdmin: isRipikAdmin(assignments),
    isInternalRipik,
    canManageUsers: canManageUsers(assignments),
    getRoleForDeployment: (id) => getRoleForDeployment(assignments, id),
    canViewDeployment: (id) => canViewDeployment(assignments, id),
    canViewSettings: (id) => canViewSettings(assignments, id),
  };
}
